var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"href":_vm.link}},[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t('btnText')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }